var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExperiences = function SvgExperiences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "adventure-g1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34731 24.658L19.1958 13.0096C19.5478 12.6635 20.1187 12.6635 20.4708 13.0096L32.3192 24.658C32.6713 25.0041 32.6713 25.5653 32.3192 25.9114C32.1501 26.0777 31.9208 26.1711 31.6817 26.1711H7.98481C7.48689 26.1711 7.08325 25.7742 7.08325 25.2847C7.08325 25.0496 7.17824 24.8242 7.34731 24.658Z",
    fill: "#F8D90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66811 24.7201L9.30948 17.246C9.6448 16.918 10.1885 16.918 10.5238 17.246L18.1651 24.7201C18.5005 25.0481 18.5005 25.5799 18.1651 25.9079C18.0041 26.0654 17.7857 26.1538 17.558 26.1538H2.27526C1.80105 26.1538 1.41663 25.7778 1.41663 25.314C1.41663 25.0913 1.50709 24.8776 1.66811 24.7201Z",
    fill: "#F8AE0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sun",
    d: "M28.4195 15.1323C30.251 15.1323 31.7357 13.6476 31.7357 11.8161C31.7357 9.98469 30.251 8.5 28.4195 8.5C26.5881 8.5 25.1034 9.98469 25.1034 11.8161C25.1034 13.6476 26.5881 15.1323 28.4195 15.1323Z",
    fill: "#F8D90B"
  }))));
};
export default SvgExperiences;